{
  "auth": {
    "onboarding": {
      "foreign": {
        "prompt": "Enter your medical details.",
        "fullName": "Full name",
        "specialty": "Specialty",
        "specialtyPlaceholder": "e.g. Cardiology",
        "specialtyChoose": "Select your specialty",
        "specialtyGroupSpecialty": "Specialties",
        "specialtyGroupSubspecialty": "Subspecialties",
        "specialtyOther": "Other (not in the list)",
        "specialtyOtherLabel": "Your specialty",
        "specialtyUnknown": "That specialty is not in the list. Please choose again.",
        "degree": "Degree",
        "degreePlaceholder": "e.g. MD or MBChB",
        "country": "Country that issued your licence",
        "countryPlaceholder": "Select a country",
        "city": "City",
        "license": "Medical licence number (optional)",
        "licenseHint": "The number issued by your own country.",
        "notice": "These details are saved without verification, and your profile will be shown as “Unverified”.",
        "incomplete": "Enter your name, specialty, degree, country and city.",
        "licenseTaken": "This licence number is already registered to another account.",
        "notAllowed": "This path is only for numbers from outside Iran. Please enter your medical council number.",
        "unverified": "Unverified"
      }
    }
  }
}
